'use client'

import { ThemeProvider as NextThemeProvider, useTheme } from 'next-themes'
import { Toaster } from 'sonner'

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const { theme, systemTheme } = useTheme()

  return (
    <NextThemeProvider
      attribute="class"
      defaultTheme={systemTheme}
      disableTransitionOnChange
    >
      {children}

      <Toaster
        position="bottom-right"
        theme={theme === 'light' || systemTheme === 'light' ? 'light' : 'dark'}
        toastOptions={{
          style: {
            background: 'var(--color-card)',
            borderColor: 'var(--color-border)',
          },
        }}
      />
    </NextThemeProvider>
  )
}
